import Vue from "vue";
export default {
  namespaced: true,
  state: {
    resultTableData: [],
    queryData: null,
    isTable: true,
    resultJsonData: ""
  },
  mutations: {
    SET_RESULT_TABLE_DATA(state, data) {
      state.isTable = true;
      state.resultTableData.push(data);
    },
    SET_RESULT_JSON_DATA(state, data) {
      state.isTable = false;
      state.resultJsonData = data;
    },
    SET_QUERY_DATA(state, data) {
      state.queryData = data;
    },
    CLEAR(state) {
      state.resultTableData = [];
      state.resultJsonData = "";
    }
  },
  actions: {
    getData({ commit, state }, { data, pageIndex }) {
      if (data) {
        commit("SET_QUERY_DATA", data);
        commit("CLEAR");
      } else {
        data = state.queryData;
      }

      return Vue.prototype
        .$http({
          url: "/gavial/v1/dw/view/data/sql",
          method: "POST",
          data: Object.assign({}, data, { pageIndex }),
          transformRequest: [
            function(data) {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            }
          ],
          timeout: 60 * 1000 * 10,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(res => {
          if (res.headers["x-return-type"] === "dataframe") {
            commit("SET_RESULT_TABLE_DATA", res.data.data);
            return {
              page: {
                pageIndex: res.data.pageIndex,
                hasMore: res.data.hasMore
              },
              timeUsed: res.data.timeUsed,
              schema: res.data.data.schema,
              inputParams: res.data.inputParams
            };
          } else if (res.headers["x-return-type"] === "json") {
            commit(
              "SET_RESULT_JSON_DATA",
              JSON.stringify(res.data.data, null, 2)
            );
            return {
              timeUsed: res.data.timeUsed
            };
          }
        });
    },
    refush({ commit }) {
      commit("CLEAR");
    }
  }
};
